module.exports = __webpack_public_path__ + "static/media/trayCard.6f614d94.png";